import { render, staticRenderFns } from "./CourseCardsFilters6.vue?vue&type=template&id=1122291e&"
import script from "./CourseCardsFilters6.vue?vue&type=script&lang=js&"
export * from "./CourseCardsFilters6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports